import React, { PropsWithChildren } from 'react'

import { SectionProps } from './Section.props'

import { SectionContent } from './Section.styled'

const Container = ({
  children,
  ...props
}: PropsWithChildren<Record<string, unknown>> & SectionProps) => {
  return <SectionContent {...props}>{children}</SectionContent>
}

export default Container
